export { default } from './HomeHero.vue';